<template>
    <popup-modal
        :title="$t('auth.language_preferences').toString()"
        :has-close-button="false"
        :close-on-click="false"
    >
        <div class="w-600">
            <div v-if="fetchingLanguages && fetchingCommunicationLanguages">
                <loading></loading>
            </div>
            <div v-else class="flex justify-between">
              <div class="flex flex-col">
                <h2 class="text-heading-1 text-medium first-letter:uppercase mb-8">
                  {{ $t('general.your_language') + ' 💻' }}
                </h2>
                <select-dropdown
                    v-model="form.language"
                    :options="languages"
                    class="w-288"
                >{{ $t('languages.interface_language.description') }}
                </select-dropdown>
              </div>

              <div class="flex flex-col justify-between">
                <h2 class="text-heading-1 text-medium first-letter:uppercase mb-8">
                  {{ $t('general.your_communication_language') + ' 💬' }}</h2>
                <select-dropdown
                    v-model="form.communication_language"
                    :options="communicationLanguages"
                    class="w-288"
                >{{ $t('languages.communication_language.description') }}
                    </select-dropdown>
                    <span class="text-primary-80 block mt-8 italic text-body-sm">
                        {{ $t('languages.communication_language.info') }}
                    </span>
                </div>

            </div>
            <div class="flex justify-end mt-24">
                <simple-button
                    display="success"
                    @click="save"
                    icon="save"
                    :disabled="!form.language || !form.communication_language"
                    :loading="form.submitting"
                >{{ $t('general.save') }}
                </simple-button>
            </div>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from "./ui/PopupModal.vue";
import SimpleButton from "./ui/SimpleButton.vue";
import SvgIcon from "./ui/SvgIcon.vue";
import SelectDropdown from "./forms/SelectDropdown.vue";
import Form from "../etc/forms/Form";
import * as languages from "../services/LanguageService";
import * as users from "../services/UserService";
import Loading from "./ui/Loading.vue";
import User from "../models/User";
import {normalizeJson} from "../../shared/helpers";
import {useRepo} from "pinia-orm";

export default {
    components: {Loading, SelectDropdown, SvgIcon, SimpleButton, PopupModal},
    props: {
        user: {type: User, required: true}
    },
    data() {
        return {
            form: this.generateForm(),
            languages: [],
            communicationLanguages: [],

            fetchingLanguages: true,
            fetchingCommunicationLanguages: true,
        }
    },
    methods: {
        generateForm() {
            return new Form([
                {name: 'language', value: this.user.language, rules: ['required']},
                {name: 'communication_language', value: this.user.communication_language, rules: ['required']}
            ])
        },
        save() {
            this.form.submit(data => users.update(this.user.id, {
                data: { attributes: data }
            }))
                .then((result) => {
                    return useRepo(User).save(normalizeJson(result));
                })
                .then(() => this.$emit('saved'));
        },
    },
    beforeMount() {
        languages.interfaceLanguages().then((data) => {
            this.languages = data
            this.fetchingLanguages = false;
        });
        languages.communicationLanguages().then((data) => {
            this.communicationLanguages = data;
            this.fetchingCommunicationLanguages = false;
        });
    }
}
</script>
